import axios from '../setup/axios';

export default function initVideo() {
    document.querySelectorAll('.article-video, .two-column.has-video, .hero.has-video').forEach($container => {
        const $trigger = $container.querySelector('.video-icon');
        const $videoContainer = $container.querySelector('.video-container');
        const $articleVideoContainer = $container.querySelector('.article-video-container');
        const $image = $container.querySelector('img');
        let $video = $container.querySelector('iframe');
        let $videoLink = null;
        let $blockedContentID = null;

        const $blockedContent = $container.querySelector('.uc-embedding-container');
        if ($blockedContent) {
            $blockedContentID = $container.querySelector('.uc-embedding-container').id;
        }

        if (!$video) {
            $video = $container.querySelector('video');
        }

        if ($video !== null && $video !== undefined && $video.src !== undefined && $video.src !== null && $video.src !== "") {
            $videoLink = $video.src;
        } else if (
            $articleVideoContainer &&
            $articleVideoContainer.querySelector("source") !== undefined &&
            $articleVideoContainer.querySelector("source") !== null &&
            $articleVideoContainer.querySelector("source").src !== undefined &&
            $articleVideoContainer.querySelector("source").src !== null &&
            $articleVideoContainer.querySelector("source").src !== ""
        ) {
            $videoLink = $articleVideoContainer.querySelector("source").src;
        } else if (
            $videoContainer &&
            $videoContainer.dataset !== undefined &&
            $videoContainer.dataset !== null &&
            $videoContainer.dataset.videolink !== undefined &&
            $videoContainer.dataset.videolink !== null &&
            $videoContainer.dataset.videolink !== ""
        ) {
            $videoLink = $videoContainer.dataset.videolink;
            delete $videoContainer.dataset.videolink;
        }

        if (!$video) {
            $videoLink = $container.dataset.videolink;
        }

        let $setPreview = $videoLink && $videoLink !== undefined && $videoLink !== null && $videoLink.includes('youku');

        if (
            $setPreview &&
            (($image !== undefined && $image !== null && $image.classList.contains('youku-image')) ||
                ($articleVideoContainer && $articleVideoContainer.classList.contains('youku-background')))
        ) {
            let afterEmbed = $videoLink.split('/')[4];

            let videoID = afterEmbed.substring(0, afterEmbed.indexOf('='));
            let clientID = afterEmbed.substring(afterEmbed.lastIndexOf('=') + 1);

            let url = 'https://api.youku.com/videos/show.json?video_id=' + videoID + '&client_id=' + clientID;

            axios
                .get(url)
                .then(response => {
                    let responseImage = null;

                    if (
                        response !== undefined &&
                        response !== null &&
                        response.data !== undefined &&
                        response.data !== null
                    ) {
                        if (response.data.bigThumbnail !== undefined && response.data.bigThumbnail !== null) {
                            responseImage = response.data.bigThumbnail;
                        } else if (response.data.thumbnail !== undefined && response.data.thumbnail !== null) {
                            responseImage = response.data.thumbnail;
                        }
                    }

                    if (responseImage !== null) {
                        if (
                            $image !== null &&
                            $image !== undefined &&
                            $image.classList !== null &&
                            $image.classList !== undefined &&
                            $image.classList.contains('youku-image')
                        ) {
                            $image.setAttribute('src', responseImage);
                            $image.classList.remove('is-hidden');
                        }

                        if (
                            $articleVideoContainer !== undefined &&
                            $articleVideoContainer !== null &&
                            $articleVideoContainer.classList !== null &&
                            $articleVideoContainer.classList !== undefined &&
                            $articleVideoContainer.classList.contains('youku-background')
                        ) {
                            $articleVideoContainer.style.backgroundImage = "url('" + responseImage + "')";
                        }

                        if ($blockedContentID && $blockedContent.id === $blockedContentID) {
                            $blockedContent.style.backgroundImage = "url('" + responseImage + "')";
                            $blockedContent.style.backgroundSize = 'cover';
                        }
                    }
                })
                .catch(e => {
                    console.log(e);
                });
        }

        function hideVideo() {
            let $currentVideo = $container.querySelector('iframe');
            if (
                $currentVideo !== null &&
                $currentVideo !== undefined &&
                $currentVideo.src !== null &&
                $currentVideo.src !== undefined
            ) {
                $currentVideo.setAttribute('data-src', $currentVideo.src);
                $currentVideo.src = '';
            }

            $container.classList.remove('video-visible');
        }

        if ($trigger) {
            $trigger.addEventListener('click', event => {
                event.preventDefault();

                if ($video !== null && $video !== undefined) {
                    if (
                        $video &&
                        $video.querySelector("source") !== undefined &&
                        $video.querySelector("source") !== null &&
                        $video.querySelector("source").src !== undefined &&
                        $video.querySelector("source").src !== null &&
                        $video.querySelector("source").src !== ""
                    ) {
                        $video.src = $video.querySelector("source").src;
                    }


                    if ($video.src !== null && $video.src !== undefined) {
                        if($video.nodeName === "IFRAME") {
                            $video.src = $video.src  + "?autoplay=1&mute=1&controls=1"
                        } else {
                            $video.setAttribute('autoplay', 'true');
                            $video.setAttribute('controls', 'true');
                            $video.setAttribute('allow', 'autoplay encrypted-media');
                        }
                    }
                }

                $container.classList.add('video-visible');
            });
        }

        if ($videoContainer) {
            $videoContainer.addEventListener('click', event => {
                event.preventDefault();
                hideVideo();
            });
        }

        document.addEventListener('keydown', function (e) {
            if (e.code === 'Escape') {
                hideVideo();
            }
        });
    });
}
